/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment'
import 'moment/locale/pt';
import { Box, Button, Modal, Typography } from '@mui/material';
import api from '../../services/api';

import PublishIcon from '@mui/icons-material/Publish';
import FixedContainer from '../../components/Container';
import LoadingComponent from '../../components/LoadingComponent';
import CustomizedTables from '../../components/Table';
import NewWorkSheetModal from './components/newWorkSheetModal';
import { enqueueSnackbar } from 'notistack';
import { GetFetch } from '../../services/apiBase';

const WorkSheets = props => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [openNewModal, setOpenNewModal] = useState(false);
  const [sheets, setSheets] = useState(null);
  
  const COLUMNSTABLE = [
    {
      headerName: 'ID',
      type: 'deafult',
      value: {
        first: {
          value: 'id'
        },
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Nome da planilha',
      type: 'default',
      value: {
        first: {
          value: 'filename'
        }
      }
    },
    {
      headerName: 'Nome do arquivo',
      type: 'default',
      value: {
        first: {
          value: 'raw_filename'
        }
      }
    },
    {
      headerName: 'Tipo',
      type: 'default',
      value: {
        first: {
          value: 'process'
        }
      }
    },
    {
      headerName: 'Usuário',
      type: 'default',
      value: {
        first: {
          value: 'username'
        }
      }
    },
    {
      headerName: 'Status da carga',
      type: 'bool',
      value: {
        first: {
          value: 'is_loaded'

        }
      },
      trueMessage: 'Carregada',
      falseMessage: 'Não carregada',
      noData: 'Não informado'
    },
  ]

  const handleOpenNewModal = () => {
    setOpenNewModal(true)
  }

  const handleClose = () => {
    setOpenNewModal(false);
  }

  const getSheet = useCallback(async () => {
    setLoading(true)
    try {
      const response = await GetFetch('/financial/showSpreadSheetStatus');
      setSheets(response.data);
      setError(false)
    } catch (error) {
      console.log(error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, []);

  const handleSubmitLoad = useCallback(async (sheet) => {
      setLoading(true)
      setSheets(null);
      try {
        await api.get(
          `tools/loadSpreadSheet?id=${sheet.id}&file=${sheet.raw_filename}&fileName=${sheet.fileName}&userName=${sheet.username}`,
        );
        enqueueSnackbar('Carga em planilha realizada com sucesso!', { variant: 'success' });
      } catch (error) {
        enqueueSnackbar('Erro ao dar carga em planilha.', { variant: 'error' });
        
      } finally {
        getSheet();
      }
    }, [getSheet]
  );

  const handleIcon = (item) => {
    return (
      !item.is_loaded && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '50%',
            cursor: 'pointer'
          }}
          onClick={() => handleSubmitLoad(item)}
        >
          <PublishIcon color="primary" />
        </Box>
      )
    )
  }

  const tableComponent = () => {
    return (
      <Box>
        {sheets && sheets.length > 0
          ? 
          <>
            <CustomizedTables
              data={sheets}
              columns={COLUMNSTABLE}
              moreOptionsTitle={'Editar'}
              moreOptions={handleIcon}
            />
          </>
          :
          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            margin: 3
          }}>
            <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
              Não foram encontradas planilhas
            </Typography>
          </Box>
        }
      </Box>
    )
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar as planilhas
        </Typography>
      </Box>
    )
  }

  useEffect(() => {
    getSheet()
  }, []);

  moment.locale('pt')
  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
            Planilhas
          </Typography>

          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: 1,
            marginTop: 1,
          }}>
              
            <Box>
              <Button variant="contained" color='success' sx={{ marginRight: 2 }} onClick={handleOpenNewModal}>Novo</Button>
            </Box>
          </Box>
          {loading ? <LoadingComponent /> :
            error ? errorMessage() :
            sheets && sheets.length === 0 ? 
              <Box sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center'
              }}>
                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                  No momento não existem planilhas para listar
                </Typography>
              </Box>
              :
              <>
                {tableComponent()}
              </>
          }
        </Box>
      </FixedContainer>

      <Modal
        open={openNewModal}
        onClose={handleClose}
      >
        <NewWorkSheetModal
          onClose={handleClose}
          getList={getSheet}
        />
      </Modal>
    </>
  );
}

export default WorkSheets;
